import { useState } from 'react';
import { useToast } from '@facephi/ui-react';

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

export function useCopyToClipboard() {
  const { toastManager } = useToast();

  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      toastManager({
        type: 'success',
        message: 'Copied value',
        duration: 3000,
        testId: 'copied-value',
      });
      return true;
    } catch (error) {
      setCopiedText(null);
      return false;
    }
  };

  return {
    copiedText,
    copy,
  };
}
